import { useEffect, useState, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import * as api from "../api/api";
import Loading from "../Components/Loading";
import Select from "react-select";
import Option from "react-select";
import { Snackbar, Alert } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { BiSearch } from "react-icons/bi";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button as MaterialButton } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import { useDebounce } from "@uidotdev/usehooks";

export default function AdminUserToTeam() {
  const { language } = useLanguage();
  const pageTitle = "AdminUserToTeam";
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [successSnackbar, setSuccessSnackbar] = useState({
    show: false,
    assign: false,
  });
  const tableBodyRef = useRef();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [selectedTenantId, setSelectedTenantId] = useState(
    JSON.parse(sessionStorage.getItem("userTenant")).tenantId ?? 1
  );

  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const delay = 500; // Adjust the delay as needed (in milliseconds)
  const [searchRunning, setSearchRunning] = useState(false);
  const searchValue = useDebounce(inputValue, delay);

  const handleInputChange = (event) => {
    setInputValue(event);
  };

  useEffect(() => {
    setIsTyping(false);
    setSearchRunning(true);
    console.log("Stopped typing:", searchValue);
    // You can perform any action when the user stops typing here
    // make the api call now
    if (searchValue.length < 3) {
      // if clearing the field, run the api request, else do not run
      if (searchValue.length === 0) {
        getAllUsers(null, "");
      } else {
        setSearchRunning(false);
      }
    } else {
      setCurrentPage(1);
      getAllUsers(null, searchValue);
    }
  }, [searchValue]);

  function getAllUsers(pageNo, userName) {
    let tenantId = selectedTenantId ?? 1;
    console.log("Paulo passed here!");
    pageNo = pageNo ?? 1;

    api
      .getUsersOfTenant(tenantId, pageNo, 30, userName)
      .then((response) => {
        console.log(response.data.object);
        /*const filteredUsers = response.data.object.forEach((user) => {
          let user = user.user;
        });*/

        const arrayOfUsers = response.data.object.userRoles.map(
          (obj) => obj.user
        );

        setNumberOfPages(
          response.data.object.totalPages == 0
            ? 1
            : response.data.object.totalPages
        );
        setNumberOfItems(response.data.object.totalSize);

        setSearchRunning(false);

        setUsers(arrayOfUsers);
        setSearchRunning(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getAllTeams() {
    setIsLoading(true);
    api
      .getAllTeams()
      .then((response) => {
        //console.log(response);
        setTeams(response.data.object);
        const fetchedOptions = response.data.object.map((item) => ({
          value: item.teamId,
          label: item.name,
        }));
        setTeamOptions(fetchedOptions);

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }

  function changeSelectedTeam(event, user, teamType) {
    //console.log(event.target.value);
    console.log(user, event);

    if (teamType === "admin") {
      console.log(event);
      // figure out if assigning or unassigning
      let actionFlag = "";

      if (user.adminTeams.length > event.length) {
        actionFlag = "unassign";
        console.log("unassign");
      } else {
        actionFlag = "assign";
        console.log("assign");
      }

      if (actionFlag === "assign") {
        event.forEach((e) => {
          const payload = {
            isAdminTeam: true,
            teamId: e.value,
            username: user.username,
          };
          api
            .assignUserToTeam(payload)
            .then((response) => {
              console.log(response);
              setUsers((prevUsers) => {
                const updatedUsers = prevUsers.map((u) =>
                  u.username === user.username
                    ? { ...u, adminTeams: [...u.adminTeams, e.value] }
                    : u
                );
                return updatedUsers;
              });

              setSuccessSnackbar({ show: true, assign: true });
            })
            .catch((error) => {
              console.log(error);
            });
        });
      } else {
        // unassign, match the odd one out of the event and the user data
        console.log(user.adminTeams);
        console.log(event);

        const getIdEvent = (item) => item.value;
        const getIdUser = (item) => item.teamId;

        const idsArray1 = user.adminTeams.map(getIdUser);
        const idsArray2 = event.map(getIdEvent);

        // Find the odd one out based on the 'id' field
        const oddOneOut = [...idsArray1, ...idsArray2].filter((id) => {
          return idsArray1.indexOf(id) === -1 || idsArray2.indexOf(id) === -1;
        });

        const payload = {
          isAdminTeam: true,
          teamId: oddOneOut[0],
          username: user.username,
        };

        // delete the oddoneout
        api
          .unAssignUserToTeam(payload)
          .then((response) => {
            console.log(response);
            setUsers((prevUsers) => {
              const updatedUsers = prevUsers.map((u) =>
                u.username === user.username
                  ? {
                      ...u,
                      adminTeams: u.adminTeams.filter(
                        (id) => id !== oddOneOut[0]
                      ),
                    }
                  : u
              );
              return updatedUsers;
            });
            setSuccessSnackbar({ show: true, assign: false });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      let payload = {
        isAdminTeam: false,
        teamId: event.value,
        username: user.username,
      };

      if (payload.teamId === 0) {
        console.log("unassign");
        console.log(user);
        payload.teamId = user.team.teamId;
        api.unAssignUserToTeam(payload).then((response) => {
          console.log(response);
          // Update state directly by modifying the users array
          setUsers((prevUsers) => {
            const updatedUsers = prevUsers.map((u) =>
              u.username === user.username
                ? { ...u, team: { ...u.team, teamId: user.team.teamId } }
                : u
            );
            return updatedUsers;
          });

          setSuccessSnackbar({ show: true, assign: false });
        });
      } else {
        api
          .assignUserToTeam(payload)
          .then((response) => {
            console.log(response);
            // Update state directly by modifying the users array
            setUsers((prevUsers) => {
              const updatedUsers = prevUsers.map((u) =>
                u.username === user.username
                  ? { ...u, team: { ...u.team, teamId: payload.teamId } }
                  : u
              );
              return updatedUsers;
            });

            setSuccessSnackbar({ show: true, assign: true });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  useEffect(() => {
    setIsLoading(true);
    checkAuthorization("USER_TO_TEAM").then((result) => {
      if (result) {
        setIsLoading(true);
        getAllUsers();
        getAllTeams();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  return isLoading ? (
    <Loading></Loading>
  ) : (
    <div className="main-content-container">
      <div className="main-content">
        <p className="main-content__title">
          {strings[pageTitle][language].pageName}
        </p>
        <hr className="main-content-title__hr" />
        <div className="form-group row">
          <InputGroup className="mb-3">
            <Form.Control
              placeholder={strings[pageTitle][language].search}
              aria-label="Search"
              aria-describedby="basic-addon2"
              onChange={(event) => {
                handleInputChange(event.target.value);
              }}
            />
            <InputGroup.Text id="basic-addon2">
              <BiSearch />
            </InputGroup.Text>
          </InputGroup>
        </div>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={successSnackbar.show}
          autoHideDuration={3000}
          onClose={() =>
            setSuccessSnackbar({ ...successSnackbar, show: false })
          }
        >
          <Alert severity={"success"}>
            {successSnackbar.assign
              ? strings[pageTitle][language].successSnackbar
              : strings[pageTitle][language].unassignSnackbar}
          </Alert>
        </Snackbar>
        {searchRunning ? (
          <Loading></Loading>
        ) : (
          <table style={{ borderSpacing: "2px", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>{strings[pageTitle][language].tableHeaders[0]}</th>
                <th>{strings[pageTitle][language].tableHeaders[1]}</th>
                <th>{strings[pageTitle][language].tableHeaders[2]}</th>
              </tr>
            </thead>
            <tbody ref={tableBodyRef}>
              {users.map((user) => {
                const selectedTeams =
                  user.adminTeams.length > 0
                    ? user.adminTeams.map((adminTeam) => {
                        const teamId = adminTeam.teamId;
                        return (
                          teamOptions.find((item) => item.value === teamId) ||
                          {}
                        );
                      })
                    : [];
                const normalTeam = user.team
                  ? teamOptions.find(
                      (item) => item.value === user.team.teamId
                    ) || {}
                  : "";

                return (
                  <tr id={user.userId} key={user.userId}>
                    <td style={{ width: "15%" }}>
                      <p>{user.name}</p>
                      <p>({user.username})</p>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="form-inline">
                        <Select
                          style={{ border: "none" }}
                          defaultValue={normalTeam}
                          onChange={(value) => {
                            console.log(value);
                            changeSelectedTeam(value, user, "normal");
                          }}
                          options={[
                            {
                              value: 0,
                              label: strings[pageTitle][language].none,
                            },
                            ...teamOptions,
                          ]}
                        >
                          <Option value={0}> </Option>
                          {teams.map((team) => {
                            return (
                              <Option value={team.teamId} key={team.teamId}>
                                {team.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                    </td>
                    <td style={{ width: "35%" }}>
                      <Select
                        options={teamOptions}
                        isMulti={true}
                        onChange={(value) => {
                          changeSelectedTeam(value, user, "admin");
                        }}
                        defaultValue={selectedTeams}
                      ></Select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <nav className="pagination-container">
          <ul className="pagination">
            <li>
              <MaterialButton
                onClick={() => {
                  // pressed first button
                  getAllUsers(1);
                  setCurrentPage(1);
                }}
                disabled={currentPage == 1 || currentPage == 0}
              >
                <FirstPageIcon></FirstPageIcon>{" "}
                {strings[pageTitle][language].first}
              </MaterialButton>
            </li>
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed prev
                  getAllUsers(currentPage - 1);
                  setCurrentPage(currentPage - 1);
                }}
                disabled={currentPage == 1 || currentPage == 0}
              >
                <ArrowBackIosIcon></ArrowBackIosIcon>{" "}
                {strings[pageTitle][language].previous}
              </MaterialButton>
            </li>
          </ul>

          <p>
            {strings[pageTitle][language].page} {currentPage}{" "}
            {strings[pageTitle][language].of} {numberOfPages} ({numberOfItems}{" "}
            {strings[pageTitle][language].items})
          </p>
          <ul className="pagination">
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed next
                  getAllUsers(currentPage + 1);
                  setCurrentPage(currentPage + 1);
                }}
                disabled={currentPage === numberOfPages}
              >
                {strings[pageTitle][language].next}{" "}
                <ArrowForwardIosIcon></ArrowForwardIosIcon>
              </MaterialButton>
            </li>
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed last
                  getAllUsers(numberOfPages);
                  setCurrentPage(numberOfPages);
                }}
                disabled={currentPage == numberOfPages}
              >
                {strings[pageTitle][language].last}
                <LastPageIcon></LastPageIcon>
              </MaterialButton>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
